import { FaIcon } from '@ifixit/icons';
import { faSignIn } from '@fortawesome/pro-solid-svg-icons';

export function SSOButton({ text, href }: { text: string; href: string }) {
   return (
      <a href={href} className="w-full" id="ssoLogin">
         <button className="w-full px-0 font-medium min-h-10">
            <FaIcon icon={faSignIn} boxSize="20px" color="brand.500" />
            <span className="ml-2">{text}</span>
         </button>
      </a>
   );
}
